import { useContext } from 'react';
import { EoiContext } from '../providers/EoiProvider';
function useEoiContext() {
    return useContext(EoiContext);
}
export default useEoiContext;
